import React, { useState } from "react";
import { useSelector } from "react-redux";
import StepCards from "../../components-v2/onboarding/StepCards";
import PlanCreationForm from "../../components-v2/onboarding/PlanCreationForm";
import GymOwnerOnboarding from "../../components-v2/onboarding/GymOwnerOnboarding";
import DashboardVisibilityStep from "../../components-v2/onboarding/steps/DashboardVisibilityStep";
import { onboardingSteps } from "../../components-v2/onboarding/data/OnboardingData";
import "../../styles-v2/onboarding/v2-onboarding.css";
import { selectUser } from "../../components/auth/auth.selector";

const OnboardingCenter = () => {
  const userInfoData = useSelector(selectUser);

  const [activeTab, setActiveTab] = useState("wizard");
  const [activeStep, setActiveStep] = useState(1);
  const [onboardedCount] = useState(3);

  return (
    <div className="v2-onboarding">
      <div className="v2-onboarding__header">
        <h1 className="v2-onboarding__title">Onboarding Center</h1>
        <p className="v2-onboarding__subtitle">
          Manage subscription plans and onboard new gym owners
        </p>
      </div>

      <div className="v2-onboarding__tabs">
        <button
          className={`v2-onboarding__tab ${activeTab === "wizard" ? "v2-onboarding__tab--active" : ""
            }`}
          onClick={() => setActiveTab("wizard")}
        >
          Onboarding Wizard
        </button>

        <button
          className={`v2-onboarding__tab ${activeTab === "list" ? "v2-onboarding__tab--active" : ""
            }`}
          onClick={() => setActiveTab("list")}
        >
          Onboarded List ({onboardedCount})
        </button>
      </div>

      <StepCards
        steps={onboardingSteps}
        activeStep={activeStep}
        onStepClick={setActiveStep}
      />

      <div className="v2-onboarding__content">
        {activeStep === 1 && <PlanCreationForm userInfoData={userInfoData} />}

        {activeStep === 2 && (
          <GymOwnerOnboarding onComplete={() => setActiveStep(3)} />
        )}

        {activeStep === 3 && (
          <DashboardVisibilityStep
            onNext={() => setActiveStep(4)}
            onBack={() => setActiveStep(2)}
          />
        )}

        {activeStep === 4 && (
          <div className="v2-onboarding__placeholder">
            Gym Features Configuration (To be implemented)
          </div>
        )}

        {activeStep === 5 && (
          <div className="v2-onboarding__placeholder">
            Import Members (To be implemented)
          </div>
        )}
      </div>
    </div>
  );
};

export default OnboardingCenter;
